import React from 'react'

import Box from '@material-ui/core/Box'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { CreateButton, useTranslate } from 'react-admin'

import { orange } from '../../constants/colorConstants'

const useStyles = makeStyles((theme) => ({
  message: {
    marginTop: '36px',
    marginBottom: '16px',
  },
  messageAlone: {
    marginTop: '36px',
    marginBottom: '36px',
  },
  button: {
    ...theme.mundi.font.roboto700Normal,
    paddingLeft: '24px',
    paddingRight: '24px',
    paddingTop: '16px',
    paddingBottom: '16px',
    borderRadius: '28px',
    border: `solid 1px ${orange}`,
    color: orange,
    fontSize: '13px',
    lineHeight: '15.23px',
    marginBottom: '30px',
  },
}))

export const EventCreditLineEmpty = (props) => {
  const classes = useStyles()
  const translate = useTranslate()
  return (
    <Box className={props.className} textAlign="center" m={1}>
      <Typography paragraph className={classes.message}>
        {translate('resources.creditlines.events.empty.noInvoice.message')}
      </Typography>
      <CreateButton
        basePath="/invoices"
        className={classes.button}
        label={'resources.creditlines.events.empty.noInvoice.button'}
        icon={<></>}
      ></CreateButton>
    </Box>
  )
}
